import { MolsonBox } from '@components/reusable'
import { molsonStyled } from '@theme'

export const InputLabelWrapper = molsonStyled(MolsonBox)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: 10
})
